import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MainLayoutComponent } from "./shared/layout/app-layouts/main-layout.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { AuthComponent } from "@app/auth/auth.component";
import { AuthLayoutComponent } from "./shared/layout/app-layouts/auth-layout.component";
// import { RoleResolveService } from "./core/resolver/role-resolve.service";

const routes: Routes = [
  {
		path: "", redirectTo: 'purchase', pathMatch: 'full',
	},
  {
    path: 'unauthorized',
    component: AuthLayoutComponent,
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [AuthGuard]
  },
  {
    path: "",
    component: MainLayoutComponent,
    data: { pageTitle: "" },
    children: [
      {
        path: "",
        redirectTo: "purchase",
        pathMatch: "full"
      },   
      {
	      path: 'settings',
	      loadChildren:() => import('./settings/settings.module' ).then(m => m.SettingsModule) ,
        data: {pageTitle: 'routerSettings', rights:'gate2b.settings.'},
        canActivate: [AuthGuard]
			},
      { 
        path: 'purchase',
        loadChildren: () => import('./features/purchase/purchase.module').then(m => m.PurchaseModule),
        data: { pageTitle: "routerPurchase" },
        canActivate: [AuthGuard]
      },
      { path: "**", redirectTo: "purchase"}
    ]
  },
  
  

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
